import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Offer } from 'src/app/stores/stores';
import { getSelectedStore } from 'src/app/public/store/+state/stores.selectors';

@Component({
  selector: 'app-offer-price',
  templateUrl: './offer-price.component.html',
  styleUrls: ['./offer-price.component.scss'],
})
export class OfferPriceComponent implements OnInit, OnDestroy, OnChanges {
  @Input() menuItem: Offer;

  @Input() locale: string;
  @Input() currency: string;
  @Input() currencySymbol: string;
  @Input() isAdminOrderCaptureUpdate: boolean;
  @Input() isOverlayMode: boolean = false;

  variantPriceDisplay: string = 'SHOW_ALL_VARIANTS';
  private destroyed$ = new Subject<void>();

  constructor(private store: Store) {}

  ngOnInit() {
    this.store
      .pipe(select(getSelectedStore), takeUntil(this.destroyed$))
      .subscribe((store) => {
        this.variantPriceDisplay =
          store?.settings?.VARIANT_PRICE_DISPLAY || 'SHOW_ALL_VARIANTS';
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    // Removed debug console logs
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
